import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { selectPartnerAccess } from 'legacy/lut/features/partner360/configuration'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import {
  ATTENTION_STATUS_BITS,
  getAttentionStatusIntroKey,
  getAttentionStatusRole,
} from 'partner360/entities/attentionStatuses'

import { selectCockpitOffering, selectCockpitUserAccess } from '../../../../model/selectors'
import { AttentionStatusCompleteness } from '../../../cockpitAttentionStatuses/components/attentionStatusCompleteness'
import { AttentionStatusCompletenessOverall } from '../../../cockpitAttentionStatuses/components/attentionStatusCompletenessOverall'
import { AttentionIntroFootSlotProvider } from '../../../cockpitAttentionStatuses/hooks/useAttentionIntroSlot'

import styles from './CockpitPlanDeck.module.scss'

/**
 * The selected plan's completeness, opened from the deck: the attention detail of a plan not yet
 * planned — its sections on the left, on the right what makes it planned and its signature — without
 * the statuses around it. On `Overall`, the offerings' own completeness and signatures.
 */
export const PlanCompletenessDetail = () => {
  const offering = useSelector(selectCockpitOffering)
  const { role } = useSelector(selectCockpitUserAccess)
  const { isDistributor } = useSelector(selectPartnerAccess)
  /* The signature strip of the detail is drawn under the lead text, as in the attention tile. */
  const [foot, setFoot] = useState<HTMLElement | null>(null)

  if (offering === ProgramTypes.Overall) {
    return (
      <div className={styles.completenessOverall}>
        <AttentionStatusCompletenessOverall />
      </div>
    )
  }

  return (
    <AttentionIntroFootSlotProvider container={foot}>
      <div className={styles.completenessDetail}>
        <div className={styles.completenessMain}>
          <AttentionStatusCompleteness />
        </div>
        <div className={styles.completenessSide}>
          <p className={styles.completenessIntro}>
            <Translation
              span
              text={getAttentionStatusIntroKey(
                ATTENTION_STATUS_BITS.planned,
                getAttentionStatusRole(role),
                isDistributor
              )}
            />
          </p>
          <div ref={setFoot} />
        </div>
      </div>
    </AttentionIntroFootSlotProvider>
  )
}

PlanCompletenessDetail.displayName = 'PlanCompletenessDetail'
